import { StatisticsTranslation } from './statistics.translation.en';

export const statisticsTranslation: StatisticsTranslation = {
  filters: {
    monthFrom: 'Miesiąc od',
    monthTo: 'Miesiąc do',
    processes: 'Procesy',
    recruiters: 'Rekruterzy',
    reset: 'Wyczyść',
    search: 'Szukaj',
  },
  table: {
    initialCount: 'Liczba analiz',
    loading: 'Ładowanie...',
    noData: 'Brak danych do wyświetlenia',
    process: 'Proces',
    recruiter: 'Rekruter',
    recruiterSummary: 'Podsumowanie rekrutera',
    repeatedCount: 'Liczba powtórzonych analiz',
    total: 'Razem',
  },
  title: 'Statystyki przetwarzania CV',
};
